import {
  MutationOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { signOutChat } from '../components/Chat';
import { getLogoutUrl } from '../utils/helpers';
import axios from './axios';
import { useWelcomeQuery } from './getWelcomeDetails';

const isLocal = window.location.hostname.includes('localhost');

const handleLogout = async () => {
  const { data } = await axios.post(
    `${import.meta.env.VITE_CUSTOMERS_API_URL}/v1/customers/logout`,
    {}
  );

  return data;
};

interface LogoutMutationOptions extends MutationOptions {
  isSessionTimeout?: boolean;
}

const useLogoutMutation = (options: LogoutMutationOptions = {}) => {
  const queryClient = useQueryClient();
  const { data: welcomeData } = useWelcomeQuery();
  const logoutClubUrl = welcomeData?.userInfo?.clubInfo?.logoutURL;
  const sessionTimeoutURL = welcomeData?.userInfo?.clubInfo?.sessionTimeoutURL;
  const { isSessionTimeout, ...mutationOptions } = options;

  return useMutation({
    mutationFn: handleLogout,
    onSettled: () => {
      signOutChat();
      queryClient.invalidateQueries();
      if (isLocal) {
        document.cookie = `mpr_access_token=; Max-Age=-99999999;`;
        document.cookie = `mpr_id_token=; Max-Age=-99999999;`;
      }

      // Regular logout: always use logoutURL
      // Session inactivity: use sessionTimeoutURL if it exists, otherwise fall back to logoutURL
      const redirectUrl = isSessionTimeout
        ? sessionTimeoutURL || logoutClubUrl
        : logoutClubUrl;
      if (redirectUrl) {
        window.location.assign(getLogoutUrl(redirectUrl));
      }
    },
    ...mutationOptions,
  });
};

export default useLogoutMutation;
